import api from 'utils/api';

export const registerReferrerApi = (data) =>
	api.post('/referrer/register', data);
